import { Button, FileInput, TextInput } from '@mantine/core'
import { IconUpload } from '@tabler/icons'
import { AxiosResponse } from 'axios'

import { MaskedPhoneNumberWithCode, MaskedTaxDocumentCPF } from '@/lib/utils/masks'

const acceptTypes = ['image/gif', 'image/png', 'image/jpeg', 'image/webp', 'image/bmp']

interface Props {
  inputProps: any
  callback?: (data: AxiosResponse | undefined, status: number | undefined) => void
}

export const FirstName = ({ inputProps }: Props) => (
  <TextInput {...inputProps} label="Primeiro nome" placeholder="Primeiro nome" type="text" />
)

export const LastName = ({ inputProps }: Props) => (
  <TextInput {...inputProps} label="Sobrenome" placeholder="Sobrenome" type="text" />
)

export const Email = ({ inputProps }: Props) => (
  <TextInput {...inputProps} label="E-mail" placeholder="E-mail" type="email" />
)

export const TaxDocument = ({ inputProps }: Props) => (
  <TextInput
    {...inputProps}
    label="CPF"
    placeholder="CPF"
    type="text"
    component={MaskedTaxDocumentCPF}
  />
)

export const PhoneNumber = ({ inputProps }: Props) => (
  <TextInput
    {...inputProps}
    label="Telefone"
    placeholder="Telefone"
    type="text"
    component={MaskedPhoneNumberWithCode}
  />
)

export const Birthdate = ({ inputProps }: Props) => <TextInput {...inputProps} />

export const Password = ({ inputProps }: Props) => (
  <TextInput {...inputProps} label="Senha" placeholder="Senha" type="password" />
)

export const ConfirmPassword = ({ inputProps }: Props) => (
  <TextInput
    {...inputProps}
    label="Confirmar Senha"
    placeholder="Confirmar Senha"
    type="password"
  />
)

export const OldPassword = ({ inputProps }: Props) => (
  <TextInput {...inputProps} label="Senha antiga" placeholder="Senha antiga" type="password" />
)

export const Picture = ({ inputProps }: Props) => (
  <Button variant="outline" leftIcon={<IconUpload />} component="label" fullWidth>
    Alterar foto
    <FileInput
      {...inputProps}
      placeholder="Foto"
      label="Foto"
      multiple
      accept={acceptTypes.join(',')}
      sx={{ display: 'none' }}
    />
  </Button>
)
